import { render, staticRenderFns } from "./devicebelonglist.vue?vue&type=template&id=15343c4c&scoped=true&"
import script from "./devicebelonglist.vue?vue&type=script&lang=js&"
export * from "./devicebelonglist.vue?vue&type=script&lang=js&"
import style0 from "./devicebelonglist.vue?vue&type=style&index=0&id=15343c4c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15343c4c",
  null
  
)

export default component.exports